package com.macrofocus.eflux.network.line

import com.macrofocus.eflux.deckgl.toJSonArray
import com.macrofocus.eflux.ui.morphing.combineLineStringAtRelativeDistances
import org.locationtech.jts.geom.Geometry
import org.locationtech.jts.geom.LineString

sealed interface GeometryLineData
: LineCapability {
    val longName: String?
    val logicalGeometry: Geometry?
    val physicalGeometry: Geometry?

    val combinedLogical: LineString
    val combinedPhysical: LineString?

    val logicalGeometryArray: Array<Array<Double>>?
    val physicalGeometryArray: Array<Array<Double>>?

    companion object {
        val empty: GeometryLineData = EagerGeometryLineData(null, null, null)
    }
}

abstract class AbstractGeometryLineData(
) : GeometryLineData {
    override val combinedLogical: LineString
        get() = combined.first
    override val combinedPhysical: LineString?
        get() = combined.second

    override val logicalGeometryArray: Array<Array<Double>>? by lazy {
        (logicalGeometry as? LineString)?.toJSonArray()
    }

    override val physicalGeometryArray: Array<Array<Double>>? by lazy {
        (physicalGeometry as? LineString)?.toJSonArray()
    }

    val combined : Pair<LineString,LineString?> by lazy {
        val physical = physicalGeometry as LineString?
        val logical = logicalGeometry as LineString
        if (physical != null) combineLineStringAtRelativeDistances(
            logical,
            physical
        ) else Pair(logical, physical)
    }
}

class LazyGeometryLineData(
    nameProvider: () -> String?,
    logicalGeometryProvider: () -> Geometry?,
    physicalGeometryProvider: () -> Geometry?
) : AbstractGeometryLineData(),GeometryLineData {
    override val longName: String? by lazy { nameProvider() }
    override val logicalGeometry: Geometry? by lazy { logicalGeometryProvider() }
    override val physicalGeometry: Geometry? by lazy { physicalGeometryProvider() }

    override fun toString(): String {
        return "LazyGeometryLineData(name=$longName, logicalGeometry=$logicalGeometry, physicalGeometry=$physicalGeometry)"
    }
}

class EagerGeometryLineData(
    override val longName: String?,
    override val logicalGeometry: Geometry?,
    override val physicalGeometry: Geometry?
) : AbstractGeometryLineData(),GeometryLineData {
    override fun toString(): String {
        return "EagerGeometryLineData(name=$longName, logicalGeometry=$logicalGeometry, physicalGeometry=$physicalGeometry)"
    }
}
